import { Alert, Loader } from "@aws-amplify/ui-react"
import { useEffect, useRef, useState } from "react"
import { apiFollowBuddy, apiGetAllBuddiesByUser, apiSearchBuddy } from "../api/api"
import { useDispatch, useSelector } from "react-redux"
import { setBuddies, follow } from "../store/buddiesSlice"
import { BuddyCard } from "./components/buddy-card"
import { useAuthenticator } from "@aws-amplify/ui-react"
export const BuddiesPage = ({ searchText, onError }) => {
    const dispatch = useDispatch()
    const { user } = useAuthenticator((context) => [context.user]);
    const [isLoading, setIsLoading] = useState(false)
    const [searchInProgress, setSearchInProgress] = useState(false)
    const [foundBuddies, setFoundBuddies] = useState([])

    const [followOpertaionInProgress, setFollowOperationInProgress] = useState(false)
    const buddies = useSelector(state => {
        if (searchText?.length > 1)
            return (state.buddies.items.filter((value, index) => (value.name?.toLowerCase().includes(searchText?.toLowerCase())) ||
                (value.email?.toLowerCase().includes(searchText?.toLowerCase()))))
        else
            return (state.buddies.items)
    }
    )
    const hasFetchedBuddies = useRef(false)

    const getAllBuddiesByUser = async () => {
        try {
            setIsLoading(true)
            const buddiesResult = await apiGetAllBuddiesByUser(user.userId)
            dispatch(setBuddies({
                items: buddiesResult.data?.buddies.filter((buddy) => buddy.id !== user.userId)
            }))
        } catch (e) {
            console.log(e)
        } finally {
            setIsLoading(false)
        }
    }

    const searchBuddy = async () => {
        try {
            setSearchInProgress(true)
            const searchResult = await apiSearchBuddy(searchText)
            setFoundBuddies(searchResult.data?.buddies)
        } catch (e) {
            console.log(e)
            onError("Network Error")
        } finally {
            setSearchInProgress(false)
        }
    }



    useEffect(() => {
        if (searchText?.length > 1) {
            if (!searchInProgress)
                searchBuddy()

        } else
            setFoundBuddies([])

    }, [searchText])

    useEffect(() => {
        if (!buddies) {
            //console.log('No buddies saved locally, fetching')
            if (!hasFetchedBuddies.current) {
                getAllBuddiesByUser()
                hasFetchedBuddies.current = true
            }
        } else {
            //console.log('Buddies cached')
        }
    }, [user]);

    return (
        <div
            className="user-profile-container w-100 h-100"
            style={{
                textAlign: 'start'
            }}>
            <div className="my-2 w-100" style={{
                maxWidth: '800px'
            }}>
                {
                    isLoading &&
                    <div className="d-flex justify-content-center m-2">
                        <Loader className="me-2" />
                        <span>Loading...</span>
                    </div>
                }

                {
                    foundBuddies?.length > 0 && searchText?.length > 0 &&
                    <h4>Found:</h4>
                }

                {searchText?.length > 0 && foundBuddies?.map((buddy, index) => {
                    const isItOurBuddy = buddies.some((value) => value.buddy === buddy.buddy)
                    return (<div key={index}>
                        <BuddyCard
                            buddy={buddy}
                            isBuddy={isItOurBuddy}
                            followOpertaionInProgress={followOpertaionInProgress}
                            onButtonClicked={async () => {
                                try {
                                    setFollowOperationInProgress(true)
                                    const result = await apiFollowBuddy(user, buddy.id, buddy.name, buddy.email, !isItOurBuddy);
                                    if (result.data?.message === "ok") {
                                        dispatch(follow({
                                            buddy: buddy,
                                            unfollow: isItOurBuddy
                                        }))
                                    }
                                } catch (e) {
                                    onError("Network error in apiFollowBuddy")
                                } finally {
                                    setFollowOperationInProgress(false)
                                }
                            }} />
                    </div>)
                }
                )
                }
                {
                    foundBuddies?.length > 0 &&
                    <h4>My Buddies:</h4>
                }
                {!isLoading && (buddies?.length ?? 0) === 0 &&
                    <Alert variation="info"
                        isDismissible={false}
                        hasIcon={true}
                        heading="You have no Buddies yet.">
                        Use the searchbox above to search your friends by email or by name.
                    </Alert>
                }
                {
                    buddies?.map((buddy, index) =>
                        <div key={index} className="w-100">
                            <BuddyCard
                                buddy={buddy}
                                isBuddy={true}
                                followOpertaionInProgress={followOpertaionInProgress}
                                onButtonClicked={async () => {
                                    try {
                                        setFollowOperationInProgress(true)
                                        const result = await apiFollowBuddy(user, buddy.id, buddy.name, buddy.email, false);
                                        if (result.data?.message === "ok") {
                                            dispatch(follow({
                                                buddy: buddy,
                                                unfollow: true
                                            }))
                                        }
                                    } catch (e) {
                                        onError("Network error in apiFollowBuddy")
                                    } finally {
                                        setFollowOperationInProgress(false)
                                    }
                                }} />
                        </div>
                    )
                }
                <div style={{ height: '5rem' }}>

                </div>
            </div>
        </div>
    )
}